import exitIntent from 'exit-intent'

export const onLeavePage = (onLeave) => {
  // Initialise
  exitIntent({
    threshold: 5,
    maxDisplays: 1,
    eventThrottle: 200,
    onExitIntent: () => {
      if (
        !window.location.pathname === '/' &&
        !window.location.pathname.includes('signup') &&
        !window.location.pathname.includes('yellow') &&
        !window.location.pathname.includes('gratis') &&
        !window.location.pathname.includes('karriar') &&
        !window.location.pathname.includes('press') &&
        !window.location.pathname.includes('offert') &&
        !window.location.pathname.includes('synka') &&
        !window.location.pathname.includes('feedback')
      ) {
        onLeave()
      }
    },
  })
}
